import { render, staticRenderFns } from "./KaiTimeEditor.vue?vue&type=template&id=311894de&"
import script from "./KaiTimeEditor.vue?vue&type=script&lang=ts&"
export * from "./KaiTimeEditor.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports